import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MdCancel as DeleteIcon } from 'react-icons/md'
import styles from './LineItem.module.scss'


class LineItem extends Component {

  render = () => {

    const { index, name, description, quantity, price, isDiscountedTax, taxRate, discountedTaxRate } = this.props

    return (
      <div className={styles.lineItem}>
        <div>{index + 1}</div>
        <div><input className={styles.input} name="name" type="text" value={name} onChange={this.props.changeHandler(index)} /></div>
        {/* <div><input name="description" type="text" value={description} onChange={this.props.changeHandler(index)} /></div> */}
        <div><input className={styles.input} name="quantity" type="number" step="1" value={quantity} onChange={this.props.changeHandler(index)} onFocus={this.props.focusHandler} /></div>
        <div className={styles.currency}><input className={styles.input} name="price" type="number" step="1" min="0" value={price} onChange={this.props.changeHandler(index)} onFocus={this.props.focusHandler} /></div>
        <div className={styles.currency}>
          <select className={styles.input} name="isDiscountedTax" value={isDiscountedTax} onChange={this.props.changeHandler(index)} onFocus={undefined}>
            <option value="なし">なし</option>
            <option value="あり">あり</option>
          </select>
        </div>
        <div className={styles.currency}>
          {isDiscountedTax === 'あり' 
            ? this.props.currencyFormatter(quantity * price * (1.0 + discountedTaxRate / 100))  // Applying 8% discount tax rate
            : this.props.currencyFormatter(quantity * price * (1.0 + taxRate / 100))}
        </div>
        <div className={styles.deleteItemButtonCell}>
          <button type="button"
            className={styles.deleteItem}
            onClick={this.props.deleteHandler(index)}
          ><DeleteIcon size="1.25em" /></button>
        </div>
      </div>
    )
  }
}

export default LineItem

LineItem.propTypes = {
  index: PropTypes.number.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}


